import { useApi } from '~/composables';
import { useAsync } from '@nuxtjs/composition-api';
import { salesOrderQuery } from '~/queries/salesOrderQuery';

export const useSalesData = (maskId) => useAsync(async () => {
  const { data } = await useApi().query(salesOrderQuery(maskId));
  return data;
});
